import React, {useEffect, useRef} from 'react';
import * as ResponsiveFns from '../utilities/ResponsiveFns';
import CleanPage from './CleanPage';
import ElementCreator, {createSpecificEntity} from './ElementCreator';
import * as CoreFns from '../utilities/CoreFns';
import * as StyleFunctions from '../utilities/StyleFunctions';
function App(props){

  const ref1 = useRef();

  var doInputActions = props.doInputActions;
  var currentList = props.currentList;
  var height = props.height;
  var width = props.width;
  var idName = props.idName;
  var updatesToPropgate = props.updatesToPropagate;
  var getRef1 = props.getRef1;
  var itemPath = props.itemPath;
  var itemEdited = props.itemEdited;
  var upwardInfo = props.upwardInfo;
  var internalVariables = props.internalVariables;
  var onClickItemChangeSelection = props.onClickItemChangeSelection;
  var setItemClicked = props.setItemClicked;
  var setIsShowingSomeDropDown = props.setIsShowingSomeDropDown;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var interactionFn = props.interactionFn;
  var userNos = props.userNos;
  var organicChanges = props.organicChanges;
  var styleIn = props.styleIn;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var chains = props.chains;
  var counter = props.counter;

  var objArray = itemPath.concat(['x']);
  var entity = CoreFns.goDownPath(currentList, itemPath, 0);
  var toConsider = entity.x;

  useEffect(()=>{
    // ref1.current.focus();
    getRef1(ref1);
    CleanPage(ref1, toConsider, itemPath, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, interactionFn, organicChanges);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(()=>{
    doChanges(updatesToPropgate);
  }, [updatesToPropgate]);

  useEffect(()=>{
    CleanPage(ref1, toConsider, itemPath, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, interactionFn, organicChanges);
  }, [width, height, counter]);

  function doChanges(updatesToPropogate){

    function doInserts(aNode, piecesToAdd, isParentAndNotSibling){
      piecesToAdd.forEach((aPieceToAdd, index2)=>{
        if (aPieceToAdd.t === 't' || aPieceToAdd.t === 'a' || aPieceToAdd.t === 'br' || aPieceToAdd.t === 'tb'){
          
          var item = ElementCreator(aPieceToAdd, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, itemPath, interactionFn, organicChanges);

          if (isParentAndNotSibling){
            aNode.appendChild(item);
          }else{
            aNode.parentNode.insertBefore(item, aNode);
          }
          if (aPieceToAdd.t === 'a'){
            if(item.onclick){
              item.onclick();
            }
          }

        }else{
          if (aPieceToAdd.t === 'h'){
            var div = document.createElement('DIV');
            if (isParentAndNotSibling === 0){
              aNode.parentNode.insertBefore(div, aNode);
              do{
                if (aNode.tagName === 'DIV'){
                  aNode = false;
                }else{
                  var nextSibling = aNode.nextSibling;
                  div.appendChild(aNode);
                  aNode = nextSibling;
                }
              }while(aNode);
              if (div.childNodes.length > 0){
                aNode = div.childNodes[0];
              }else{
                aNode = div;
                isParentAndNotSibling = 1;
              }
            }else{
              aNode.appendChild(div);
              aNode = div;
            }
          }else{
            var element = document.createElement(aPieceToAdd.t);
            if (isParentAndNotSibling){
              aNode.appendChild(element);
            }else{
              aNode.parentNode.insertBefore(element, aNode);
            }
          }                      
        }
      })
    }

    function insertAfterIfCan(toAdd, aNode){
      var nextSibling = aNode.nextSibling;
      if (nextSibling){
        nextSibling.parentNode.insertBefore(toAdd, nextSibling);
      }else{
        aNode.parentNode.appendChild(toAdd);
      }
    }

    function iterateThroughChildNodesInsert(parent, p, insertPieces){
      var childNodes = parent.childNodes;
      for (var i = 0; i < childNodes.length; i++){
        if (p < 0){
          return p;
        }
        var aNode = childNodes[i];
        if (!aNode.tagName || aNode.tagName === 'B' || aNode.tagName === 'U' || aNode.tagName === 'I' || aNode.tagName === 'SPAN'){
          var relevantNode = ResponsiveFns.drillToTextNode(aNode);
          var lengthHere = relevantNode.textContent.length;
          if (lengthHere < p){
            p = p - lengthHere;
          }else{
            var beforeText = relevantNode.textContent.substr(0, p);
            var afterText = relevantNode.textContent.substr(p);
            relevantNode.textContent = beforeText;
            var toAdd = cloneNodeWithText(afterText, aNode);
            insertAfterIfCan(toAdd, aNode);

            
            if (relevantNode.length === 0){
              aNode.parentNode.removeChild(aNode);
            }
            doInserts(toAdd, insertPieces, 0);
            if (afterText.length === 0){
              toAdd.parentNode.removeChild(toAdd);
            }
            return -1;
          }            
          
        }else if (p === 0){
          doInserts(aNode, insertPieces, 0)
          return -1;
        }else{
          p = p - 1;
          var tagName = aNode.tagName;
          if (tagName === 'DIV'){
            p = iterateThroughChildNodesInsert(aNode, p, insertPieces);
          }else if (isSingularTag(tagName)){
          }else{
            console.warn(aNode.tagName);
          }
        }
      }
      if (p === 0){
        doInserts(parent, insertPieces, 1);
        return -1;
      }
    
      return p;
    }

    function isSingularTag(tagName){
      return (tagName === 'TABLE' || tagName === 'BR');
    }
    function iterateThroughChildNodesDelete(childNodes, p, l){

      for (var i = 0; i < childNodes.length; i++){
        if (p < 0 || l <= 0){
          return {p,l};
        }
        var aNode = childNodes[i];
        if (!aNode.tagName || aNode.tagName === 'B' || aNode.tagName === 'U' || aNode.tagName === 'I' || aNode.tagName === 'SPAN'){
          var relevantNode = ResponsiveFns.drillToTextNode(aNode);
          var lengthHere = relevantNode.textContent.length;
          if (lengthHere === 0){
            aNode.parentNode.removeChild(aNode);
            i--;
          }else{
            if (lengthHere <= p){
              p = p - lengthHere;
            }else{
              var beforeText = relevantNode.textContent.substr(0, p);
              var afterText = relevantNode.textContent.substr(p);
              if (afterText.length >= l){
                var afterText1 = afterText.substr(l);
                relevantNode.textContent = beforeText + afterText1;
                if (relevantNode.textContent.length === 0){
                  aNode.parentNode.removeChild(aNode);
                }
                return {p:-1,l:-1};
              }else{
                relevantNode.textContent = beforeText;
                if (relevantNode.textContent.length === 0){
                  aNode.parentNode.removeChild(aNode);
                  i--;
                }
                l = l - afterText.length;
              }
            }            
          }

        }else if (p === 0){
          var tagName = aNode.tagName;
          if (isSingularTag(tagName)){
            aNode.parentNode.removeChild(aNode);
            i--;
            l--;
          }else if (tagName === 'DIV'){
            var children = aNode.childNodes;
            var nos = children.length;
            for (var j = 0; j < nos; j++){
              insertAfterIfCan(children[0], aNode);
            }
            aNode.parentNode.removeChild(aNode);
            i --;
            l --;
          }else{
            console.warn(l);
            console.warn(aNode)
          }
        }else{
          p = p - 1;
          var tagName1 = aNode.tagName;
          if (tagName1 === 'DIV'){
            var pSet = iterateThroughChildNodesDelete(aNode.childNodes, p, l);
            p = pSet.p;
            l = pSet.l;
          }else if (isSingularTag(tagName1)){
          }else{
            console.warn(aNode.tagName);
          }
        }
      }
      return {p,l};
    }

    var needToDo = false;
    updatesToPropogate.forEach((anUpdate, index)=>{
      if (anUpdate.w.join(' ') === objArray.join(' ')){
        if (anUpdate.t === 'a'){
          iterateThroughChildNodesInsert(ref1.current, anUpdate.p, anUpdate.n);
        }else if (anUpdate.t === 'd'){
          var childNodes = ref1.current.childNodes;
          iterateThroughChildNodesDelete(childNodes, anUpdate.p, anUpdate.l);
        }else{
          console.warn(anUpdate);
        }
      }else if (anUpdate.w[0] === 'fe' || anUpdate.w[0] === 'pu'){
        var elementId1 = anUpdate.w[1];
        if (document.getElementById(elementId1)){
          var ele1 = document.getElementById(elementId1);
          if (anUpdate.w[3] === 's'){
            var item3 = createSpecificEntity(ele1.tagName, elementId1,  currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, {}, upwardInfo, onClickItemChangeSelection, itemPath, interactionFn, organicChanges);
            ele1.parentNode.insertBefore(item3, ele1);
            ele1.parentNode.removeChild(ele1);
          }else if (anUpdate.w[3] === 'x'){
            if (anUpdate.t === 'a'){
              iterateThroughChildNodesInsert(ele1, anUpdate.p, anUpdate.n);
            }else if (anUpdate.t === 'd'){
              iterateThroughChildNodesDelete(ele1.childNodes, anUpdate.p, anUpdate.l);
            }else{
              console.warn(anUpdate);
            }

          }
        }
      }else{
        var elementId = anUpdate.w[1];
        if (document.getElementById(elementId)){
          var ele = document.getElementById(elementId);
          if (anUpdate.w[2] === 's'){
            var upwardInfoHere = upwardInfo;

            var item = createSpecificEntity(ele.tagName, elementId,  currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, {}, upwardInfoHere, onClickItemChangeSelection, itemPath, interactionFn, organicChanges);
            ele.parentNode.insertBefore(item, ele);
            var parentRow = ele.parentNode;
            var tt = ele.tagName;
            ele.parentNode.removeChild(ele);
            if (tt === 'TD'){
              var gotPrevious = parentRow.previousSibling;
              if (!gotPrevious){
                ResponsiveFns.getTotalWeightAndWeightsOfARow(parentRow, currentList, internalVariables, width, height, inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
              }
            }

          }else if (anUpdate.w[2] === 'x'){
            if (anUpdate.t === 'a'){
              iterateThroughChildNodesInsert(ele, anUpdate.p, anUpdate.n);
            }else if (anUpdate.t === 'd'){
              iterateThroughChildNodesDelete(ele.childNodes, anUpdate.p, anUpdate.l);
            }else{
              console.warn(anUpdate);
            }

          }
        }
      }
    })

    function cleanUpCurrent(childNodes){
      for (var i = 0; i < childNodes.length; i++){
        var aChild = childNodes[i];
        if (!aChild.tagName){
          if (aChild.textContent.length === 0){
            aChild.parentNode.removeChild(aChild);
            i --;
          }
        }else if (aChild.tagName === 'DIV'){
          cleanUpCurrent(aChild.childNodes);
        }
      }
    }

    function cloneNodeWithText(newNodeText, oldNode){
      if (!oldNode.tagName){
        return document.createTextNode(newNodeText);
      }else{
        var item;
        if (oldNode.tagName === "SPAN"){
          item = document.createElement("SPAN");
          item.style[oldNode.style[0]] = oldNode.style[oldNode.style[0]];
        }else{
          item = document.createElement(oldNode.tagName);
        }
        var inside = cloneNodeWithText(newNodeText, oldNode.childNodes[0]);
        item.appendChild(inside);
        return item;
      } 
    }
    cleanUpCurrent(ref1.current.childNodes);

    if (needToDo){
        CleanPage(ref1, toConsider, itemPath, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, interactionFn, organicChanges);
    }
    //       //this may be an overkill, and may affect the typing. but lets leave it for now. cos we fail to do upwardInfo properly if we change all indv elements. changing indv elements selectively may also not be correct as we might be doing stuff within. 

  }

  function onInput(e){
    doInputActions(ref1);
  }

  // var top = '1.25rem'; 
  function clickOver(e){
    if (itemEdited && itemEdited.t === 'item' && itemEdited.path.join(' ') === itemPath.join(' ')){
      if (setIsShowingSomeDropDown){
        setIsShowingSomeDropDown(false);
      }
    }else{
      if (setItemClicked){
        setItemClicked(e);
      }
    }
    if (setIsClickingOnContentDiv){
      setIsClickingOnContentDiv(true);
    }
    e.stopPropagation();
  }


  function handlePaste(e) {
    var types, pastedData, savedContent;
    var editableDiv = ref1.current;
    var sel = document.getSelection();

    // Browsers that support the 'text/html' type in the Clipboard API (Chrome, Firefox 22+)
    if (e && e.clipboardData && e.clipboardData.types && e.clipboardData.getData) {

      // Check for 'text/html' in types list. See abligh's answer below for deatils on
      // why the DOMStringList bit is needed. We cannot fall back to 'text/plain' as
      // Safari/Edge don't advertise HTML data even if it is available
      types = e.clipboardData.types;
      if (((types instanceof DOMStringList) && types.contains('text/html')) || (types.indexOf && types.indexOf('text/html') !== -1)) {

        // Extract data and pass it to callback
        pastedData = e.clipboardData.getData('text/html');
        processPaste(editableDiv, pastedData, sel);

        // Stop the data from actually being pasted
        e.stopPropagation();
        e.preventDefault();
        return false;
      }
    }

    // Everything else: Move existing element contents to a DocumentFragment for safekeeping
    savedContent = document.createDocumentFragment();
    while (editableDiv.childNodes.length > 0) {
      savedContent.appendChild(editableDiv.childNodes[0]);
    }

    // Then wait for browser to paste content into it and cleanup
    waitForPastedData(editableDiv, savedContent, sel);
    return true;
  }

  function waitForPastedData(elem, savedContent, sel) {

    // If data has been processes by browser, process it
    if (elem.childNodes && elem.childNodes.length > 0) {

      // Retrieve pasted content via innerHTML
      // (Alternatively loop through elem.childNodes or elem.getElementsByTagName here)
      var pastedData = elem.innerHTML;

      // Restore saved content
      elem.innerHTML = '';
      elem.appendChild(savedContent);

      // Call callback
      processPaste(elem, pastedData, sel);
    }

    // Else wait 20ms and try again
    else {
      setTimeout(function() {
        waitForPastedData(elem, savedContent, sel)
      }, 20);
    }
  }

  function tunnelDownAndSplitUpPieces(decorators, childNodes, styles, origStyles, thingsToAdd){
    var newStyles = pullOutRelevantStyles(styles);
    // if (styles['font-weight'] === 'bolder'){
    //   decorators = decorators.concat(['B']);
    // }
    var relevantStyles = {...origStyles, ...newStyles};
    childNodes.forEach((aChild, index)=>{
      if (!aChild.tagName){
          var ele = document.createTextNode(aChild.textContent);
          var styleKeys = Object.keys(relevantStyles);
          for (var j = 0; j < styleKeys.length; j++){
            var e2 = document.createElement('SPAN');
            e2.style[styleKeys[j]] = relevantStyles[styleKeys[j]];
            e2.appendChild(ele);
            ele = e2;
          }
          for (var i = 0; i < decorators.length; i++){
            var e1 = document.createElement(decorators[i]);
            e1.appendChild(ele);
            ele = e1;
          }
          thingsToAdd.push(ele);
      }else if (aChild.tagName === 'SPAN'){
        tunnelDownAndSplitUpPieces(decorators, aChild.childNodes, aChild.style, relevantStyles, thingsToAdd);
      }else if (aChild.tagName === 'B' || aChild.tagName === 'U' || aChild.tagName === 'I'){
        tunnelDownAndSplitUpPieces(decorators.concat([aChild.tagName]), aChild.childNodes, aChild.style, relevantStyles, thingsToAdd);
      }else if (aChild.tagName === 'IMG' || aChild.tagName === 'VIDEO' || aChild.tagName === 'BR'){
      }else{
        console.warn(aChild);
      }
    })
  }

  function pullOutRelevantStyles(style){
    var outStyle = {};
    for (var i = 0; i < 200; i++){
      var aStyle = style[i.toString()];
      if (aStyle){
        // console.log(aStyle);
        // || aStyle === 'background-color'
        if (aStyle === 'color' || aStyle === 'font-family' || aStyle === 'font-size' ){
          outStyle[aStyle] = style[aStyle];
          // var ele1 = document.createElement('SPAN');  
          // ele1.style[aStyle] = spanStyle[aStyle];
          // ele1.appendChild(ele);
          // ele = ele1;
        }else{
          // console.log(aStyle);
        }
      }else{
        break;
      }        
    }
    return outStyle;
  }

  var warningGiven = false;

  function addStuff(childNodes){
    var thingsToAdd = [];
    childNodes.forEach((aChild, index)=>{
      // console.log(aChild);
      // console.log(aChild.tagName);
      if (aChild.tagName === 'META'){
      }else if (aChild.tagName === 'SPAN'){
        if (aChild.id && currentList && currentList.as[aChild.id]){

          var uuid = CoreFns.uuidScoped(userNos, currentList, ['as'], []); 
          var oldPieceClean = JSON.parse(JSON.stringify(currentList.as[aChild.id]));  
          var changes = [{t:'w',w:['as',uuid],n:oldPieceClean}];
          aChild.id = uuid;
          organicChanges(changes);
          var item = ElementCreator({t:'a', n:'SPAN', i:uuid}, currentList, internalVariables, ownVariables, urlParamsForExecution, urlHeader, chains, width, height, upwardInfo, onClickItemChangeSelection, itemPath, interactionFn, organicChanges);

          thingsToAdd.push(item);
        }else{
          tunnelDownAndSplitUpPieces([], aChild.childNodes, aChild.style, {}, thingsToAdd);
        }
      }else if (aChild.tagName === 'B' || aChild.tagName === 'I' || aChild.tagName === 'U'){
        if (aChild.id){ //this is likely the microsoft thing.
          tunnelDownAndSplitUpPieces([], aChild.childNodes, {}, {}, thingsToAdd);
        }else{
          var toAdd = [aChild.tagName];
          // for (var i = 0; i < parents.length; i++){
          //   if (parents[i] === aChild.tagName){
          //     toAdd = [];
          //     break;
          //   }
          // }
          tunnelDownAndSplitUpPieces(toAdd, aChild.childNodes, aChild.style, {}, thingsToAdd);
        }
      }else if (aChild.tagName === 'DIV'){
        var item2 = document.createElement('BR');
        thingsToAdd.push(item2);

        var insides = addStuff(aChild.childNodes);
        insides.forEach((anInside, index)=>{
          thingsToAdd.push(anInside);
        })
        // thingsToAdd.push(itemX);
      }else if (aChild.tagName === 'P' || aChild.tagName === 'PRE'){

        var item3 = document.createElement('BR');
        thingsToAdd.push(item3);

        var insides2 = addStuff(aChild.childNodes);
        insides2.forEach((anInside, index)=>{
          thingsToAdd.push(anInside);
          // itemX2.appendChild(anInside);
        })
        // thingsToAdd.push(itemX);
      }else if (aChild.tagName === 'UL' || aChild.tagName === 'LI' || aChild.tagName === 'STYLE' || aChild.tagName === 'TITLE'){
        var insides3 = addStuff(aChild.childNodes);
        insides3.forEach((anInside, index)=>{
          thingsToAdd.push(anInside);
        })
      }else if (aChild.tagName === 'BR'){
        var item1 = document.createElement('BR');
        thingsToAdd.push(item1);
      }else if (aChild.tagName === 'FONT'){
        tunnelDownAndSplitUpPieces([], aChild.childNodes, aChild.style, {}, thingsToAdd);
      }else if (!aChild.tagName){
        var tContent = aChild.textContent;
        var item31 = document.createTextNode(tContent);
        thingsToAdd.push(item31);            
      }else if (aChild.tagName === 'IMG'){
        if (!warningGiven){
          window.alert('Images cannot be added to text box');
          warningGiven = true;
        }
      }else if (aChild.tagName === 'VIDEO'){
        if (!warningGiven){
          window.alert('Videos cannot be added to text box');
          warningGiven = true;
        }
      }else{
        console.log(aChild.tagName);
        console.warn(aChild);
      }

    })
    return thingsToAdd;
  }


  function processPaste(elem, pastedData, sel) {
    // Do whatever with gathered data;
    // alert('Pasting temporarily not allowed');
    // console.log(pastedData);

    var ele = document.createElement('DIV');
    ele.innerHTML = pastedData;
    var childNodes = ele.childNodes;

    var elementsToAdd = addStuff(childNodes);
    CoreFns.squeezeIn(elementsToAdd, sel, itemPath);
    doInputActions(ref1);

    elem.focus();
  }
  var inStyle = { width:'100%', height:'100%'};
  var className = StyleFunctions.iterateClassNames('', ['textAlignment'], styleIn);
  
  return <div ref={ref1} className={className} id={idName} onPaste={handlePaste} contentEditable={true} onInput={onInput} onClick={clickOver} style={inStyle} ></div>
  
        

}

export default App;
